<div class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-tools me-2 text-primary"></i>Tools</h2>
  </div>
  <div class="card-body">

    <!-- Registration API -->
    <div class="bg-tertiary p-2 border-start border-warning border-5 mb-3">
      <h3 class="fw-bold fs-6 mb-0">Registration API</h3>
    </div>
    <div class="row">
      <div class="col-6">
        <h4 class="fw-bold bg-tertiary p-2 fs-6">About</h4>
        <p>The Registration API allows you to seamlessly integrate registration processes into your systems. It offers
        flexibility and robust functionality for managing user data efficiently.</p>
      </div>
      <div class="col-6">
        <a [href]="partnerService.getDownloadUrl('PARTNER-TOOLS-API.pdf')" download="PARTNER-TOOLS-API.pdf" class="btn btn-outline-primary w-100 fw-bold mb-4">
          <i class="bi bi-file-earmark-pdf-fill"></i>Download API Documentation
        </a>
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between bg-tertiary p-2"><h4 class="fw-bold fs-6 mb-0">API
        TOKEN</h4>
        <button class="btn btn-primary fw-bold" (click)="addToken()"><i
        class="bi bi-plus-lg me-2"></i>Add Token
      </button>
    </div>
    @for (partnerToken of partnerTokens; track partnerToken) {
      <label for="defaultToken" class="form-label fw-bold small">{{ partnerToken.label }}</label>
      <div class="input-group mb-2">
        <span class="input-group-text"><i class="bi bi-key"></i></span>
        <input id="defaultToken" type="text" class="form-control" [value]="partnerToken.token" readonly="">
        <button class="btn btn-primary fw-bold" (click)="copyToken(partnerToken, $event)">Copy</button>
        <button class="btn btn-outline-primary fw-bold" (click)="editToken(partnerToken)">Edit</button>
        <!--            <button class="btn btn-outline-primary fw-bold">Logs</button>-->
        <button class="btn btn-outline-primary fw-bold" appConfirm (click)="regenerate(partnerToken)">
          Regenerate
        </button>
        <button class="btn btn-outline-primary fw-bold" appConfirm (click)="delete(partnerToken)">Delete</button>
      </div>
    }
  </div>
</div>

<div class="bg-tertiary p-2 border-start border-warning border-5 mt-5 mb-3">
  <h3 class="fw-bold fs-6 mb-0">White-Label Embedded Registration Form & Widgets</h3>
</div>
<div class="row">
  <div class="col-6">
    <h4 class="fw-bold bg-tertiary p-2 fs-6">About</h4>
    <p>
      The White-Label Embedded Registration Form is a user-friendly solution for affiliates who prefer not to use
      the API. It allows easy integration and customization of registration forms.
    </p>

    <div class="row mt-5">
      <div class="col-6">
        <label class="form-label">Form Widget</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-robot"></i></span>
          <select [(ngModel)]="selectedFormWidget" class="form-select">
            <option [ngValue]="null">Configurable (widget ID in URL with param tfi=)</option>
            @for (formWidget of formWidgets; track formWidget) {
              <option [ngValue]="formWidget">{{ formWidget }}</option>
            }
          </select>
        </div>
      </div>

      <div class="col-6">
        <label class="form-label">Site</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-globe"></i></span>
          <select [(ngModel)]="selectedUrl" class="form-select">
            <option [ngValue]="null" disabled>Select a site</option>
            @for (site of sites; track site) {
              <option [ngValue]="site.url">{{ site.url }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    @if (selectedFormWidget) {
      <div class="row mt-3">
        <div class="col-6">
          <label class="form-label">Source type</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-type"></i></span>
            <input [(ngModel)]="selectedFormWidget.sourceType" class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <label class="form-label">
            Source Details
            @for (sourceDetail of selectedFormWidget.sourceDetails; track $index) {
              <span class="badge bg-primary me-1">{{ sourceDetail }}<i (click)="selectedFormWidget.sourceDetails.splice($index, 1)" class="bi bi-x ms-2" role="button"></i></span>
            }
          </label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-braces"></i></span>
            <input #sourceDetails class="form-control"/>
            <span (click)="sourceDetails.value.trim() && selectedFormWidget.sourceDetails.push(sourceDetails.value);sourceDetails.value = ''" class="input-group-text"><i class="bi bi-plus-circle" role="button"></i></span>
          </div>
        </div>
        @if (selectedFormWidget.folderSet && selectedFormWidget.authorizedFolderSet) {
          <div class="col-6">
            <label class="form-label">Select an image folder</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-folder"></i></span>
              <select [(ngModel)]="selectedFormWidget.folderSet" class="form-select">
                @for (folderName of generateRange(selectedFormWidget.authorizedFolderSet); track folderName) {
                  <option [value]="folderName">{{ folderName }}</option>
                }
              </select>
            </div>
          </div>
        }
        @if (selectedFormWidget.gridFormat) {
          <div class="col-6">
            <label class="form-label">Number of columns</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-grid"></i></span>
              <select [(ngModel)]="selectedFormWidget.gridFormat" class="form-select">
                @for (authorizedGridFormat of selectedFormWidget.authorizedGridFormat; track authorizedGridFormat) {
                  <option [ngValue]="authorizedGridFormat">{{ authorizedGridFormat }}</option>
                }
              </select>
            </div>
          </div>
        }
      </div>
    }

    <div class="row mt-3">
      <div class="col-6">
        @if (selectedFormWidget && selectedFormWidget.folderSet) {
          <div class="row mt-1">
            @for (zodiacSign of getZodiacSigns(); track zodiacSign) {
              <div [class]="selectedFormWidget.getGridClass()" class="mt-2">
                <img [src]="'/images/tool/form/' + selectedFormWidget.slug + '/' + selectedFormWidget.folderSet + '/' + zodiacSign + '.webp'" class="img-fluid"/>
              </div>
            }
          </div>
        }
      </div>

      <div class="col-6 text-end">
        <button (click)="copyToClipboard.copy(getContainerCode())" class="btn btn-primary fw-bold me-2">
          <i class="bi bi-copy me-3"></i>Copy Container
        </button>

        <button (click)="copyToClipboard.copy(getWidgetCode())" class="btn btn-primary fw-bold">
          <i class="bi bi-copy me-3"></i>Copy Main Code
        </button>
      </div>
    </div>
  </div>

  <div class="col-6">
    <h4 class="fw-bold bg-tertiary p-2 fs-6">Generated JS Code</h4>

    @if (this.selectedUrl) {
      <h3 class="fw-bold bg-tertiary p-2 fs-6">Container: insert at every place you need the form to be displayed</h3>
      <div class="input-group mb-2">
        <span class="input-group-text"><i class="bi bi-code-slash"></i></span>
        <code class="form-control bg-dark form-control text-light">
          <pre [innerHTML]="getContainerCode(true) | safe: 'html'" class="mb-0"></pre>
        </code>
      </div>

      <h3 class="fw-bold bg-tertiary p-2 fs-6">Main code: insert only once at the bottom of the page</h3>
    }

    <div class="input-group mb-2">
      <span class="input-group-text"><i class="bi bi-code-slash"></i></span>
      <code class="form-control bg-dark form-control text-light">
        <pre [innerHTML]="getWidgetCode(true) | safe: 'html'" class="mb-0"></pre>
      </code>
    </div>
  </div>
</div>
</div>
</div>
